import { TextField } from "../components/TextField";
import { Button } from "../components/Button";
import { Select } from "../components/Select";
import { Form, redirect } from "react-router-dom";
import {  addCustomerVehicle, getModels } from "../services/api";
import { useEffect, useState } from "react";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";



export async function AddCustomerVehicleAction ({request,params}){
	const data = await request.formData();
	const formToJSON = {};
  for (const [key, value] of [...data.entries()]) {
	formToJSON[key] = value;
  }
  formToJSON["customer_id"] = params.id;
	try{


  	const response = await addCustomerVehicle(formToJSON);


	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result = await response.json();
	return redirect(`/dashboard/vehicles/${formToJSON["license_plate"]}/services`);
} catch(e){
	console.log("error", e);
	if (e.response) {
		const errorBody = await e.response.json();
		console.log("error body", errorBody);
		alert("something went wrong");
	}
}
}

export function AddCustomerVehicle(){
	const [_models,_setModels] = useState([]);

useEffect(()=>{
		mixpanel.identify(getUserId());
	getModels().then((response)=>{
		let tempList = [];
		response.models.forEach((model)=>{
			tempList.push(model.vehicle_name);
		});
		_setModels(tempList);


	});


},[]);
	return (
	<div>
		<h1>Add A New Vehicle</h1>

		<Form method="post"  encType="multipart/form-data">

			{/* Vehicle Details  */}
			<div className="card">
				<div className="row space-between">
					<TextField
					label="Vehicle Brand & Model"
					name="vehicle_make"
					required={true}
					datalist={_models}
					// value="Hundai Elantra"
					style={{"width": "35vw"}}
					/>
					<TextField
					label="License Plate"
					name="license_plate"
					required={true}
					// value="GR 5663 24"
					style={{"width":"25vw"}}
					/>
				</div>
				<div className="row" id="vd_2">


					<TextField
					label="Year of Manufacture"
					width="15vw"
					// value="2025"
					name="year_manufacture"
					/>
					<Select
					label="Engine Capacity"
					width="20vw"
					name="capacity"
					options={["1.0L-1.8L","2.0L-2.7L","3.0L-3.4L","3.5L-3.9L"]}
					/>
					<TextField
					label="Color"
					width="15vw"
					name="colour"
					subLabel="(Optional)"
					// value="Blue"
					/>
					<TextField
					label="Milage"
					style={{"width":"15vw"}}
					subLabel="(Optional)"
					// value="4000"
					name="milage"
					/>
				</div>

				<TextField
					label="Vehicle Identification Number"
					name="vin"
					// value="49430394039403949"
					style={{"width":"35vw"}}
					/>
			</div>


			<Button
			label="Add Vehicle"
			color="blue"
			type="submit"
			id="addMemberButton"
			// onClick={()=>{alert('submit')}}
			/>
		</Form>
	</div>)
}